import { createRouter, createWebHistory } from 'vue-router';
// Import feature routes
import { featureRoutes } from './featureRoutes';
import ContactsPage from '@/pages/ContactsPage.vue'
import ChatPage from '@/pages/ChatPage.vue'
import CrewingPage from '@/pages/CrewingPage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
import FinancePage from '@/pages/FinancePage.vue'
import LoginPage from '@/pages/LoginPage.vue'
import RegisterPage from '@/pages/RegisterPage.vue'
import SplashPage from '@/pages/SplashPage.vue'
import RamsPage from '@/pages/RamsPage.vue'
import SettingsPage from '@/pages/SettingsPage.vue'
import SubhirePage from '@/pages/SubhiresPage.vue'
import TransportPage from '@/pages/TransportPage.vue'
import WikiPage from '@/pages/WikiPage.vue'
import WikiItem from '@/pages/WikiItemPage.vue'
import WikiGuide from '@/pages/WikiGuide.vue'
import WorkshopPage from '@/pages/WorkshopPage.vue'
import RepairsPage from '@/pages/workshop/RepairsPage.vue'
import LolerPage from '@/pages/workshop/LolerPage.vue'
import PatPage from '@/pages/workshop/PatPage.vue'
import PartsPage from '@/pages/workshop/PartsPage.vue'
import RepairDetails from '@/components/workshop/RepairDetails.vue'
//Paperwork
import QuotePDF from '@/pdfs/quotes/Quote1PDF.vue'
import DeliveryNotePDF from '@/pdfs/deliveryNotes/deliveryNote1PDF.vue'
import PrepListPDF from '@/pdfs/prepLists/PrepList1PDF.vue';
import RepairTagPDF from '@/pdfs/repairTags/RepairTag.vue';
import PartsBinLabel from '@/pdfs/partsOrder/PartsOrder.vue';
import PalLabel from '@/pdfs/palLabels/PalLabel.vue';

import WarehouseProject from '@/components/project/warehouseProject/ViewWarehouseProject.vue'
import ViewFreelancerComponent from '@/components/contacts/view/ViewFreelancerComponent.vue';
import PartView from '@/pages/PartView.vue'
import ConsumablesPage from '@/pages/workshop/ConsumablesPage.vue'
import OrdersPage from '@/pages/workshop/OrdersPage.vue'
import CompaniesPage from '@/pages/CompaniesPage.vue'
import CrewPage from '@/pages/crewing/CrewPage.vue'
import CrewTypesPage from '@/pages/crewing/CrewTypesPage.vue'
import ServicesPage from '@/pages/ServicesPage.vue'
import StockLayout from '@/layouts/StockLayout.vue'
import ProjectsLayout from '@/layouts/ProjectsLayout.vue'
import WikiLayout from '@/layouts/WikiLayout.vue'
import NotFoundPage from '@/pages/NotFoundPage.vue'
import { onboardingRequiresAccount } from '@/router/onboardingGuard';

// Import the tab components
// const StockOverview = () => import('@/components/stock/tabs/StockOverview.vue')
// const StockRepairs = () => import('@/components/stock/tabs/StockRepairs.vue')
// const StockScans = () => import('@/components/stock/tabs/StockScans.vue')
// const StockBookings = () => import('@/components/stock/tabs/StockBookings.vue')

const routes = [
    {
        path: '/freelancer',
        name: 'FreelancerDashboard',
        component: DashboardPage,
        meta: { dashboard: 'freelance' }
    },
    {
        path: '/assets',
        meta: { requiresAuth: true },
        name: 'Assets',
        component: () => import('@/pages/assets/EquipmentPage.vue')
    }, {
        path: '/asset/:id',
        name: 'ViewAsset',
        component: () => import('@/pages/ViewAssetPage.vue'),
        children: [
            {
                path: '',
                name: 'ViewAssetDefault',
                redirect: to => `/asset/${to.params.id}/equipment`
            },
            {
                path: 'equipment',
                name: 'AssetEquipment',
                component: () => import('@/components/assets/ViewAssetTabs/AssetEquipment.vue')
            },
            {
                path: 'categories',
                name: 'AssetCategories',
                component: () => import('@/components/assets/ViewAssetTabs/AssetCategories.vue')
            },
            {
                path: 'cases',
                name: 'AssetCases',
                component: () => import('@/components/assets/ViewAssetTabs/AssetCases.vue')
            },
            {
                path: 'overview',
                name: 'AssetOverview',
                component: () => import('@/components/assets/ViewAssetTabs/AssetOverview.vue')
            },
            {
                path: 'bookings',
                name: 'AssetBookings',
                component: () => import('@/components/assets/ViewAssetTabs/AssetBookings.vue')
            },
            {
                path: 'accessories',
                name: 'AssetAccessories',
                component: () => import('@/components/assets/accessories/AssetAccessories.vue')
            },
            {
                path: 'case-contents',
                name: 'AssetCaseContents',
                component: () => import('@/components/assets/ViewAssetTabs/AssetCaseContents.vue')
            },
            {
                path: 'labels',
                name: 'AssetLabels',
                component: () => import('@/components/assets/ViewAssetTabs/AssetLabels.vue')
            },
            {
                path: 'stock',
                name: 'AssetStock',
                component: () => import('@/components/assets/stock/AssetStock.vue')
            },
            {
                path: 'bulk-stock',
                name: 'AssetBulkStock',
                component: () => import('@/components/assets/stock/AssetBulkStock.vue')
            },
            {
                path: 'stock-transactions',
                name: 'AssetStockTransactions',
                component: () => import('@/components/assets/stock/StockTransactions.vue')
            },
            {
                path: 'test-inspect',
                name: 'AssetTesting',
                component: () => import('@/components/assets/ViewAssetTabs/AssetTestAndInspect.vue')
            },
            {
                path: 'cost',
                name: 'AssetCost',
                component: () => import('@/components/assets/ViewAssetTabs/AssetCosts.vue')
            },
            {
                path: 'risk-assessments',
                name: 'AssetRiskAssessments',
                component: () => import('@/components/assets/ViewAssetTabs/AssetRiskAssessments.vue')
            }
        ]
    }, {
        path: '/asset/:id/stock/:stockId',
        name: 'AssetStockItem',
        component: () => import('@/pages/ViewStockPage.vue'),
        children: [
            {
                path: '',
                name: 'AssetStockItemDefault',
                redirect: to => `/asset/${to.params.id}/stock/${to.params.stockId}/overview`
            },
            {
                path: 'overview',
                name: 'AssetStockItemOverview',
                component: () => import('@/components/stock/tabs/StockOverview.vue')
            },
            {
                path: 'repairs',
                name: 'AssetStockItemRepairs',
                component: () => import('@/components/stock/tabs/StockRepairs.vue')
            },
            {
                path: 'scans',
                name: 'AssetStockItemScans',
                component: () => import('@/components/stock/tabs/StockScans.vue')
            },
            {
                path: 'bookings',
                name: 'AssetStockItemBookings',
                component: () => import('@/components/stock/tabs/StockBookings.vue')
            }
        ]
    }, {
        path: '/crewing',
        name: 'Crewing',
        component: CrewingPage,
        children: [
            {
                path: '',
                name: 'CrewingDefault',
                redirect: '/crewing/crew'
            },
            {
                path: 'crew',
                name: 'CrewingCrew',
                component: CrewPage
            },
            {
                path: 'crew-types',
                name: 'CrewingTypes',
                component: CrewTypesPage
            },
            {
                path: 'crew-type/:id',
                name: 'CrewTypeDetail',
                component: () => import('@/components/crewing/CrewTypes/ViewCrewType.vue'),
                props: true
            }
        ]
    }, {
        path: '/chat',
        name: 'Chat',
        component: ChatPage
    }, {
        path: '/contacts',
        name: 'ContactsPage',
        component: ContactsPage
    }, {
        path: '/companies',
        name: 'CompaniesPage',
        component: CompaniesPage
    },
    {
        path: '/paperwork/delivery-note',
        name: 'DeliveryNotePDF',
        component: DeliveryNotePDF
    },
    {
        path: '/paperwork/repair-tag',
        name: 'RepairTagPDF',
        component: RepairTagPDF
    },  {
        path: '/paperwork/parts-order',
        name: 'PartsBinLabel',
        component: PartsBinLabel
    },
    {
        path: '/finance',
        name: 'FinancePage',
        component: FinancePage,
        children: [
            {
                path: '',
                name: 'FinanceDefault',
                redirect: '/finance/overview'
            },
            {
                path: 'overview',
                name: 'FinanceOverview',
                component: () => import('@/pages/finance/FinanceOverviewPage.vue')
            },
            {
                path: 'purchase-orders',
                name: 'FinancePurchaseOrders',
                component: () => import('@/pages/finance/PurchaseOrdersPage.vue')
            },
            {
                path: 'invoices',
                name: 'FinanceInvoices',
                component: () => import('@/pages/finance/InvoicesPage.vue')
            },
            {
                path: 'quotes',
                name: 'FinanceQuotes',
                component: () => import('@/pages/finance/QuotesPage.vue')
            }
        ]
    }, {
        path: '/freelance-staff',
        name: 'FreelanceStaffPage',
        component: () => import('@/pages/FreelanceStaffPage.vue')
    }, {
        path: '/availability/:token',
        name: 'AvailabilityRequest',
        component: () => import('@/pages/AvailabilityRequestPage.vue'),
        meta: { hideSidebar: true, public: true }
    }, {
        path: '/subhire-request/:token',
        name: 'SubhireRequest',
        component: () => import('@/pages/SubhireRequestPage.vue'),
        meta: { hideSidebar: true, public: true }
    }, {
        path: '/transport-request/:token',
        name: 'TransportRequest',
        component: () => import('@/pages/TransportRequestPage.vue'),
        meta: { hideSidebar: true, public: true }
    }, {
        path: '/quote-response/:token',
        name: 'QuoteResponse',
        component: () => import('@/pages/QuoteResponsePage.vue'),
        meta: { hideSidebar: true, public: true }
    }, {
        path: '/',
        name: 'Splash',
        component: SplashPage,
        meta: { hideSidebar: true }
    }, {
        path: '/login',
        name: 'Login',
        component: LoginPage,
        meta: { hideSidebar: true }
    }, {
        path: '/register',
        name: 'Register',
        component: RegisterPage,
        meta: { hideSidebar: true }
    }, {
        path: '/register/continue',
        redirect: '/onboarding/company',
    }, {
        path: '/onboarding',
        component: () => import('@/layouts/OnboardingLayout.vue'),
        meta: { hideSidebar: true, onboarding: true },
        beforeEnter: onboardingRequiresAccount,
        children: [
            {
                path: '',
                redirect: '/onboarding/company',
            },
            {
                path: 'company',
                name: 'OnboardingCompany',
                component: () => import('@/pages/onboarding/OnboardingCompanyPage.vue'),
                meta: { hideSidebar: true, onboarding: true },
            },
            {
                path: 'financial',
                name: 'OnboardingFinancial',
                component: () => import('@/pages/onboarding/OnboardingFinancialPage.vue'),
                meta: { hideSidebar: true, onboarding: true },
            },
            {
                path: 'locations',
                name: 'OnboardingLocations',
                component: () => import('@/pages/onboarding/OnboardingLocationsPage.vue'),
                meta: { hideSidebar: true, onboarding: true },
            },
            {
                path: 'team',
                name: 'OnboardingTeam',
                component: () => import('@/pages/onboarding/OnboardingTeamPage.vue'),
                meta: { hideSidebar: true, onboarding: true },
            },
            {
                path: 'done',
                name: 'OnboardingDone',
                component: () => import('@/pages/onboarding/OnboardingDonePage.vue'),
                meta: { hideSidebar: true, onboarding: true },
            },
        ],
    }, {
        path: '/accept-invite',
        name: 'AcceptInvite',
        component: () => import('@/pages/AcceptInvitePage.vue'),
        meta: { hideSidebar: true }
    }, {
        path: '/internal-staff',
        name: 'InternalStaffPage',
        component: () => import('@/pages/InternalStaffPage.vue')
    }, {
        path: '/logistics',
        component: () => import('@/layouts/LogisticsLayout.vue'),
        children: [
            {
                path: '',
                name: 'LogisticsRedirect',
                redirect: '/logistics/timeline'
            },
            {
                path: 'timeline',
                name: 'LogisticsTimeline',
                component: () => import('@/pages/logistics/LogisticsTimelinePage.vue')
            },
            {
                path: 'transport-requests',
                name: 'TransportRequests',
                component: () => import('@/pages/logistics/TransportRequestsPage.vue')
            },
            {
                path: 'transport',
                name: 'Transport',
                component: () => import('@/pages/logistics/TransportPage.vue')
            },
            {
                path: 'vehicles',
                name: 'Vehicles',
                component: () => import('@/pages/logistics/VehiclesPage.vue')
            },
            {
                path: 'types',
                name: 'Types',
                component: () => import('@/pages/logistics/TypesPage.vue')
            },
            {
                path: 'vehicles/:registration',
                name: 'VehicleDetails',
                component: () => import('@/pages/logistics/VehiclePage.vue')
            },
            {
                path: 'types/:id',
                name: 'TypeDetails',
                component: () => import('@/pages/logistics/TypePage.vue')
            }
        ]
    }, {
        path: '/dashboard',
        name: 'DefaultDashboard',
        component: DashboardPage,
        meta: { dashboard: 'office' }
    }, {
        path: '/operations',
        component: () => import('@/layouts/OperationsLayout.vue'),
        children: [
            {
                path: '',
                name: 'OperationsRedirect',
                redirect: '/operations/returns'
            },
            {
                path: 'returns',
                component: () => import('@/components/operations/GeneralReturns.vue')
            },
            {
                path: 'repairs',
                component: () => import('@/components/workshop/RepairsComponent.vue')
            },
            {
                path: 'outstanding',
                component: () => import('@/components/operations/OutstandingReturns.vue')
            }
        ]
    }, {
        path: '/paperwork/quote',
        name: 'QuotePdf',
        component: QuotePDF,
    },
    {
        path: '/paperwork/prep-list',
        name: 'PrepListPdf',
        component: PrepListPDF
    },
    {
        path: '/paperwork/document/:id',
        name: 'DocumentView',
        component: () => import('@/components/paperwork/DocumentView.vue')
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/layouts/ProfileLayout.vue'),
        children: [
            {
                path: '',
                name: 'ProfileTab',
                component: () => import('@/components/profile/tabs/ProfileTab.vue')
            },
            {
                path: 'chat',
                name: 'ProfileChat',
                component: () => import('@/components/profile/tabs/ChatTab.vue')
            },
            {
                path: 'calendar',
                name: 'ProfileCalendar',
                component: () => import('@/components/profile/tabs/CalendarTab.vue')
            }
        ]
    },
    {
        path: '/notifications',
        name: 'Notifications',
        component: () => import('@/pages/NotificationsPage.vue')
    },
    {
        path: '/projects',
        name: 'Projects',
        component: ProjectsLayout,
        children: [
            {
                path: '',
                name: 'ProjectsRedirect',
                redirect: '/projects/timeline'
            },
            {
                path: 'timeline',
                name: 'ProjectsTimeline',
                component: () => import('@/components/project/officeProject/ProjectsTimelineView.vue')
            },
            {
                path: 'list',
                name: 'ProjectsList',
                component: () => import('@/components/project/officeProject/ProjectsComponent.vue')
            },
            {
                path: 'quick-quotes',
                name: 'QuickQuotes',
                component: () => import('@/components/project/officeProject/QuickQuotesComponent.vue')
            }
        ]
    },
    {
        path: '/officeProject/:id',
        redirect: to => `/project/${to.params.id}`
    },
    {
        path: '/project/:id',
        name: 'Project',
        component: () => import('@/components/project/officeProject/ViewProjectComponent.vue'),
        children: [
            {
                path: '',
                name: 'ProjectOverview',
                component: () => import('@/components/project/officeProject/overview/ProjectOverViewComponent.vue')
            },
            {
                path: 'contents',
                name: 'ProjectContents',
                component: () => import('@/components/project/officeProject/widgets/EquipmentListsWidget.vue')
            },
            {
                path: 'contents/:equipmentId',
                name: 'ProjectContentsDetails',
                component: () => import('@/components/project/officeProject/projectContents/ProjectContentsComponent.vue')
            },
            {
                path: 'settings',
                name: 'ProjectSettings',
                component: () => import('@/components/project/officeProject/ProjectSettingsComponent.vue')
            },
            {
                path: 'subhires',
                name: 'ProjectSubhires',
                component: () => import('@/components/project/officeProject/subhires/ProjectSubhiresComponent.vue')
            },
            {
                path: 'remote',
                name: 'ProjectRemote',
                component: () => import('@/components/project/officeProject/widgets/RemoteAccessWidget.vue')
            },
            {
                path: 'dmx_patch/:sheetId?',
                name: 'DmxPatch',
                component: () => import('@/components/project/officeProject/DynamicTabComponent.vue'),
                props: true
            },
            {
                path: ':tabId',
                name: 'DynamicProjectTab',
                component: () => import('@/components/project/officeProject/DynamicTabComponent.vue'),
                props: true
            }
        ]
    },
    {
        path: '/services',
        name: 'ServicesPage',
        component: ServicesPage
    }, {
        path: '/warehouse-project/:projectId',
        name: 'WarehouseProject',
        component: WarehouseProject,
        children: [
            {
                path: 'prepared/:equipmentListId',
                name: 'WarehouseProjectPrepared',
                component: () => import('@/components/project/warehouseProject/WarehousePrep.vue')
            },
            {
                path: 'dispatched/:equipmentListId',
                name: 'WarehouseProjectDispatched',
                component: () => import('@/components/project/warehouseProject/WarehouseDispatch.vue')
            },
            {
                path: 'returned/:equipmentListId',
                name: 'WarehouseProjectReturned',
                component: () => import('@/components/project/warehouseProject/WarehouseReturn.vue')
            },
            {
                path: 'deprep/:equipmentListId',
                name: 'WarehouseProjectDeprep',
                component: () => import('@/components/project/warehouseProject/WarehouseDeprep.vue')
            },
            {
                path: 'patches/:equipmentListId',
                name: 'WarehouseProjectPatches',
                component: () => import('@/components/project/warehouseProject/WarehousePatches.vue')
            },
            {
                path: 'sub-rentals/:equipmentListId',
                name: 'WarehouseProjectSubRentals',
                component: () => import('@/components/project/warehouseProject/WarehouseSubRentals.vue')
            },
            {
                path: 'carnet/:equipmentListId',
                name: 'WarehouseProjectCarnet',
                component: () => import('@/components/project/warehouseProject/WarehouseCarnet.vue')
            },
            {
                path: 'cases/:equipmentListId',
                name: 'WarehouseProjectCases',
                component: () => import('@/components/project/warehouseProject/WarehouseCases.vue')
            }
        ]
    }, {
        path: '/rams',
        name: 'ViewRams',
        component: RamsPage
    }, {
        path: '/settings',
        name: 'Settings',
        component: SettingsPage,
        children: [
            {
                path: '',
                name: 'SettingsDefault',
                redirect: '/settings/system'
            },
            {
                path: 'system',
                name: 'SystemSettings',
                component: () => import('@/pages/settings/SystemSettingsPage.vue')
            },
            {
                path: 'users',
                name: 'UserSettings',
                component: () => import('@/pages/settings/UserSettingsPage.vue')
            },
            {
                path: 'roles',
                name: 'RoleSettings',
                component: () => import('@/pages/settings/RoleSettingsPage.vue')
            },
            {
                path: 'categories',
                name: 'CategoriesSettings',
                component: () => import('@/pages/settings/CategoriesPage.vue')
            },
            {
                path: 'naming-templates',
                name: 'NamingTemplatesSettings',
                component: () => import('@/pages/settings/NamingTemplatesPage.vue')
            },
            {
                path: 'documents',
                name: 'DocumentSettings',
                component: () => import('@/pages/settings/DocumentSettingsPage.vue')
            },
            {
                path: 'documents/:id',
                name: 'DocumentDetail',
                component: () => import('@/pages/settings/DocumentDetailPage.vue')
            },
            {
                path: 'email-templates/:id',
                name: 'EmailTemplateDetail',
                component: () => import('@/pages/settings/EmailTemplateDetailPage.vue')
            },
            {
                path: 'rates',
                name: 'RateSettings',
                component: () => import('@/pages/settings/RateSettingsPage.vue')
            },
            {
                path: 'store',
                name: 'StoreSettings',
                component: () => import('@/pages/settings/StoreSettingsPage.vue')
            }
        ]
    }, {
        path: '/subhire',
        name: 'SubhirePage',
        component: SubhirePage
    }, {
        path: '/transport',
        name: 'TransportPage',
        component: TransportPage
    }, {
        path: '/venues',
        name: 'VenuesPage',
        component: () => import('@/pages/VenuesPage.vue')
    },
    {
        path: '/view-venue/:id',
        name: 'ViewVenue',
        component: () => import('@/pages/ViewVenuePage.vue'),
        redirect: to => `/view-venue/${to.params.id}/overview`,
        children: [
            {
                path: 'overview',
                name: 'VenueOverview',
                component: () => import('@/components/venues/view/VenueOverviewTab.vue')
            },
            {
                path: 'address',
                name: 'VenueAddress',
                component: () => import('@/components/venues/view/VenueAddressTab.vue')
            },
            {
                path: 'staff',
                name: 'VenueStaff',
                component: () => import('@/components/venues/view/VenueStaffTab.vue')
            },
            {
                path: 'documents',
                name: 'VenueDocuments',
                component: () => import('@/components/venues/view/VenueDocumentsTab.vue')
            },
            {
                path: 'venues',
                name: 'VenueVenues',
                component: () => import('@/components/venues/view/VenueVenuesTab.vue')
            }
        ]
    },
    {
        path: '/view-contact/:id',
        name: 'ViewContact',
        component: () => import('@/components/contacts/view/ViewContactComponent.vue'),
        redirect: to => `/view-contact/${to.params.id}/overview`,
        children: [
            {
                path: 'overview',
                name: 'ContactOverview',
                component: () => import('@/components/contacts/view/ContactOverviewTab.vue')
            },
            {
                path: 'notes',
                name: 'ContactNotes',
                component: () => import('@/components/contacts/view/ContactNotesTab.vue')
            },
            {
                path: 'documents',
                name: 'ContactDocuments',
                component: () => import('@/components/contacts/view/ContactDocumentsTab.vue')
            },
            {
                path: 'address',
                name: 'ContactAddress',
                component: () => import('@/components/contacts/view/ContactAddressTab.vue')
            }
        ]
    },
    {
        path: '/view-company/:id',
        name: 'ViewCompany',
        component: () => import('@/components/contacts/view/ViewCompanyComponent.vue'),
        redirect: to => `/view-company/${to.params.id}/overview`,
        children: [
            {
                path: 'overview',
                name: 'CompanyOverview',
                component: () => import('@/components/contacts/view/CompanyOverviewTab.vue')
            },
            {
                path: 'address',
                name: 'CompanyAddress',
                component: () => import('@/components/contacts/view/CompanyAddressTab.vue')
            },
            {
                path: 'staff',
                name: 'CompanyStaff',
                component: () => import('@/components/contacts/view/CompanyStaffTab.vue')
            },
            {
                path: 'documents',
                name: 'CompanyDocuments',
                component: () => import('@/components/contacts/view/CompanyDocumentsTab.vue')
            },
            {
                path: 'company-roles',
                name: 'CompanyRoles',
                component: () => import('@/components/contacts/view/CompanyRolesTab.vue')
            }
        ]
    },
    {
        path: '/view-service/:id',
        name: 'ViewService',
        component: () => import('@/components/contacts/modals/ServiceModal.vue'),
        props: () => ({
            data: {},  // This will be populated by the component
            type: 'view'
        })
    },
    {
        path: '/view-staff-member/:id',
        name: 'ViewStaffMember',
        component: () => import('@/components/contacts/modals/InternalStaffModal.vue'),
        props: () => ({
            data: {},  // This will be populated by the component
            type: 'view'
        })
    },
    {
        path: '/view-freelancer/:id',
        name: 'ViewFreelancer',
        component: ViewFreelancerComponent
    },
    {
        path: '/wiki',
        name: 'Wiki',
        component: WikiLayout,
        children: [
            {
                path: '',
                redirect: '/wiki/items'
            },
            {
                path: 'items',
                name: 'WikiPage',
                component: WikiPage
            },
            {
                path: 'import',
                name: 'WikiImport',
                component: () => import('@/pages/WikiImportPage.vue')
            },
            {
                path: 'editor',
                name: 'WikiMasterEditor',
                meta: { requiresSystemAdmin: true },
                component: () => import('@/pages/WikiMasterEditorPage.vue')
            },
            {
                path: 'scrapers',
                name: 'WikiScrapers',
                meta: { requiresSystemAdmin: true },
                component: () => import('@/pages/WikiScrapersPage.vue')
            },
            {
                path: 'image-generator',
                name: 'WikiImageGenerator',
                meta: { requiresSystemAdmin: true },
                component: () => import('@/pages/WikiImageGeneratorPage.vue')
            },
            {
                path: 'item/:id',
                name: 'WikiItem',
                component: WikiItem,
                redirect: to => `/wiki/item/${to.params.id}/overview`,
                children: [
                    {
                        path: 'overview',
                        name: 'WikiItemOverview',
                        component: () => import('@/components/wiki/wikiTabs/OverviewTab.vue')
                    },
                    {
                        path: 'prep',
                        name: 'WikiItemPrep',
                        component: () => import('@/components/wiki/wikiTabs/PrepTab.vue')
                    },
                    {
                        path: 'deprep',
                        name: 'WikiItemDePrep',
                        component: () => import('@/components/wiki/wikiTabs/DePrepTab.vue')
                    },
                    {
                        path: 'guides',
                        name: 'WikiItemGuides',
                        component: () => import('@/components/wiki/wikiTabs/GuidesTab.vue')
                    }
                ]
            },
            {
                path: 'guide/:id',
                name: 'WikiGuide',
                component: WikiGuide
            },
            {
                path: 'suppliers',
                name: 'WikiSuppliers',
                component: () => import('@/components/wiki/WikiSuppliersPlaceholder.vue')
            }
        ]
    },
    {
        path: '/workshop',
        name: 'Workshop',
        component: WorkshopPage,
        children: [
            {
                path: '',
                name: 'WorkshopDefault',
                redirect: '/workshop/repairs'
            },
            {
                path: 'repairs',
                name: 'Repairs',
                component: RepairsPage
            },
            {
                path: 'repairs/:id',
                name: 'RepairDetails',
                component: RepairDetails
            },
            {
                path: 'loler',
                name: 'Loler',
                component: LolerPage
            },
            {
                path: 'pat',
                name: 'Pat',
                component: PatPage
            },
            {
                path: 'parts',
                name: 'Parts',
                component: PartsPage
            },
            {
                path: 'parts/:id',
                name: 'PartDetail',
                component: () => import('@/pages/workshop/PartDetailPage.vue')
            },
            {
                path: 'consumables',
                name: 'Consumables',
                component: ConsumablesPage
            },
            {
                path: 'orders',
                name: 'Orders',
                component: OrdersPage
            }
        ]
    },
    {
        path: '/stock',
        component: StockLayout,
        children: [
            {
                path: '',
                name: 'StockDefault',
                redirect: '/stock/overview'
            },
            {
                path: 'overview',
                component: () => import('@/components/stock/tabs/StockOverview.vue')
            },
            {
                path: 'items',
                component: () => import('@/components/stock/tabs/StockItems.vue')
            },
            {
                path: 'items/:id',
                component: () => import('@/components/stock/ViewStockItem.vue')
            },
            {
                path: 'locations',
                component: () => import('@/components/stock/tabs/StockLocations.vue')
            },
            {
                path: 'history',
                component: () => import('@/components/stock/tabs/StockHistory.vue')
            }
        ]
    },
    // {
    //     path: '/stock/:id',
    //     name: 'StandaloneStockItem',
    //     component: () => import('@/pages/ViewStockPage.vue'),
    //     children: [
    //         {
    //             path: '',
    //             redirect: to => `/stock/${to.params.id}/overview`
    //         },
    //         {
    //             path: 'overview',
    //             name: 'StandaloneStockItemOverview',
    //             component: () => import('@/components/stock/tabs/StockOverview.vue')
    //         },
    //         {
    //             path: 'repairs',
    //             name: 'StandaloneStockItemRepairs',
    //             component: () => import('@/components/stock/tabs/StockRepairs.vue')
    //         },
    //         {
    //             path: 'scans',
    //             name: 'StandaloneStockItemScans',
    //             component: () => import('@/components/stock/tabs/StockScans.vue')
    //         },
    //         {
    //             path: 'bookings',
    //             name: 'StandaloneStockItemBookings',
    //             component: () => import('@/components/stock/tabs/StockBookings.vue')
    //         }
    //     ]
    // },
    {
        path: '/dashboard/finance',
        name: 'FinanceDashboard',
        component: DashboardPage,
        meta: { dashboard: 'finance' }
    },
    {
        path: '/dashboard/workshop',
        name: 'WorkshopDashboard',
        component: DashboardPage,
        meta: { dashboard: 'workshop' }
    },
    {
        path: '/dashboard/logistics',
        name: 'LogisticsDashboard',
        component: DashboardPage,
        meta: { dashboard: 'logistics' }
    },
    {
        path: '/warehouse',
        component: () => import('@/layouts/WarehouseLayout.vue'),
        children: [
            {
                path: '',
                name: 'WarehouseDefault',
                redirect: '/warehouse/today'
            },
            {
                path: 'today',
                component: () => import('@/components/warehouse/tabs/WarehouseTodayLayout.vue'),
                children: [
                    {
                        path: '',
                        name: 'WarehouseTodayDefault',
                        redirect: '/warehouse/today/in'
                    },
                    {
                        path: 'in',
                        name: 'WarehouseTodayIn',
                        component: () => import('@/components/warehouse/tabs/WarehouseInComponent.vue')
                    },
                    {
                        path: 'out',
                        name: 'WarehouseTodayOut',
                        component: () => import('@/components/warehouse/tabs/WarehouseOutComponent.vue')
                    }
                ]
            },
            {
                path: '3-day',
                name: 'Warehouse3Day',
                component: () => import('@/components/warehouse/tabs/Timeline3DayView.vue')
            },
            {
                path: 'week',
                name: 'WarehouseWeek',
                component: () => import('@/components/warehouse/tabs/TimelineWeekView.vue')
            },
            {
                path: 'month',
                name: 'WarehouseMonth',
                component: () => import('@/components/warehouse/tabs/WarehouseMonthComponent.vue')
            }
        ]
    },
    {
        path: '/office',
        name: 'OfficeDashboard',
        component: DashboardPage,
        meta: { dashboard: 'office' }
    },
    {
        path: '/shortages',
        name: 'Shortages',
        component: () => import('@/pages/ShortagesPage.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/workshop/parts/:id',
        name: 'PartView',
        component: PartView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/freelance-staff/:id',
        name: 'ViewFreelanceStaff',
        component: () => import('@/components/contacts/modals/FreelanceStaffModal.vue'),
        props: (route) => ({
            data: {},  // This will be populated by the component
            type: route.params.id === 'new' ? 'add' : 'view'
        })
    },
    {
        path: '/venues/:id',
        name: 'VenueDetail',
        component: () => import('@/components/contacts/modals/VenueModal.vue'),
        props: () => ({
            data: {},  // This will be populated by the component
            type: 'view'
        })
    },
    {
        path: '/health-and-safety',
        name: 'HealthAndSafety',
        component: () => import('@/pages/HealthAndSafetyPage.vue'),
        children: [
            {
                path: '',
                name: 'HealthAndSafetyDefault',
                redirect: '/health-and-safety/dashboard'
            },
            {
                path: 'dashboard',
                name: 'HealthSafetyDashboard',
                component: () => import('@/pages/health-safety/DashboardPage.vue')
            },
            {
                path: 'risk-assessments',
                name: 'RiskAssessments',
                component: () => import('@/pages/health-safety/RiskAssessmentsPage.vue')
            },
            {
                path: 'method-statements',
                name: 'MethodStatements',
                component: () => import('@/pages/health-safety/MethodStatementsPage.vue')
            },
            {
                path: 'risks',
                name: 'Risks',
                component: () => import('@/pages/health-safety/RisksPage.vue')
            },
            {
                path: 'cosh',
                name: 'COSH',
                component: () => import('@/pages/health-safety/CoshPage.vue')
            },
            {
                path: 'incidents',
                name: 'Incidents',
                component: () => import('@/pages/health-safety/IncidentsPage.vue')
            }
        ]
    },
    // Test routes for fake data
    {
        path: '/test/contacts',
        name: 'TestContacts',
        component: () => import('@/pages/TestDataPage.vue'),
        props: { dataType: 'contacts' }
    },
    {
        path: '/test/health',
        name: 'TestHealthStatus',
        component: () => import('@/features/meta/components/HealthStatus.vue')
    },
    {
        path: '/test/companies',
        name: 'TestCompanies',
        component: () => import('@/pages/TestDataPage.vue'),
        props: { dataType: 'companies' }
    },
    {
        path: '/test/services',
        name: 'TestServices',
        component: () => import('@/pages/TestDataPage.vue'),
        props: { dataType: 'services' }
    },
    {
        path: '/test/venues',
        name: 'TestVenues',
        component: () => import('@/pages/TestDataPage.vue'),
        props: { dataType: 'venues' }
    },
    {
        path: '/test/view-contact/:id',
        name: 'TestViewContact',
        component: () => import('@/components/contacts/modals/ContactModal.vue'),
        props: () => ({
            data: {},
            type: 'view',
            useFakeData: true
        })
    },
    {
        path: '/test/view-company/:id',
        name: 'TestViewCompany',
        component: () => import('@/components/contacts/modals/CompanyModal.vue'),
        props: () => ({
            data: {},
            type: 'view',
            useFakeData: true
        })
    },
    {
        path: '/test/view-service/:id',
        name: 'TestViewService',
        component: () => import('@/components/contacts/modals/ServiceModal.vue'),
        props: () => ({
            data: {},
            type: 'view',
            useFakeData: true
        })
    },
    {
        path: '/test/view-venue/:id',
        name: 'TestViewVenue',
        component: () => import('@/components/contacts/modals/VenueModal.vue'),
        props: () => ({
            data: {},
            type: 'view',
            useFakeData: true
        })
    },
    {
        path: '/procurement',
        name: 'procurement',
        component: () => import('@/components/procurement/Procurement.vue')
    },
    {
        // Redirect old assets/categories route to new settings/categories route
        path: '/assets/categories',
        redirect: '/settings/categories'
    },
    {
        // Redirect old assets/equipment route to new assets route
        path: '/assets/equipment',
        redirect: '/assets'
    },
    {
        // Redirect old assets/cases route to assets (cases are now in assets/equipment)
        path: '/assets/cases',
        redirect: '/assets'
    },
    {
        // Redirect old individual case view to asset view
        path: '/assets/cases/:id',
        redirect: to => `/asset/${to.params.id}`
    },
    {
        path: '/project/projectContents/:id',
        name: 'ProjectContents',
        component: () => import('@/components/project/officeProject/projectContents/ProjectContentsComponent.vue')
    },
    {
        path: '/pdfs/pal-labels/:assetData',
        name: 'PalLabel',
        component: PalLabel,
        props: true
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFoundPage,
        meta: { hideSidebar: true }
    },
    {
        path: '/dashboard/crew',
        name: 'CrewDashboard',
        component: DashboardPage,
        meta: { dashboard: 'crew' }
    },
    {
        path: '/dashboard/shooting',
        name: 'ShootingDashboard',
        component: DashboardPage,
        meta: { dashboard: 'shooting' }
    },
    {
        path: '/dashboard/crewing',
        name: 'CrewingDashboard',
        component: DashboardPage,
        meta: { dashboard: 'crew' }
    },
    {
        path: '/dashboard/freelance',
        name: 'FreelanceDashboard',
        component: DashboardPage,
        meta: { dashboard: 'freelance' }
    },
    {
        path: '/freelance/diary',
        name: 'FreelanceDiary',
        component: () => import('@/components/freelance/FreelancerDiaryPage.vue')
    },
    {
        path: '/freelance/projects',
        name: 'FreelanceProjects',
        component: () => import('@/components/freelance/FreelancerProjectsPage.vue')
    },
    {
        path: '/freelance/invoices',
        name: 'FreelanceInvoices',
        component: () => import('@/components/freelance/FreelancePlaceholder.vue')
    },
    {
        path: '/freelance/expenses',
        name: 'FreelanceExpenses',
        component: () => import('@/components/freelance/FreelancePlaceholder.vue')
    },
    {
        path: '/freelance/contacts',
        name: 'FreelanceContacts',
        component: () => import('@/components/freelance/FreelancePlaceholder.vue')
    },
    {
        path: '/freelance/settings',
        name: 'FreelanceSettings',
        component: () => import('@/components/freelance/FreelancerSettings.vue')
    },
    {
        path: '/freelance/profile',
        name: 'FreelanceProfile',
        component: () => import('@/components/freelance/FreelancerProfilePage.vue')
    }
];

// ====================================================================
// LEGACY ROUTES - TODO: Migrate to feature-based routes incrementally
// ====================================================================
const legacyRoutes = routes;

// Combine legacy routes with feature routes
// Feature routes come after legacy routes (lower priority)
const allRoutes = [...legacyRoutes, ...featureRoutes];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: allRoutes
});


// Add router guards for authentication
import { useAuthStore } from '@/stores/authStore';
import { getDashboardByRole, getDashboardByUsername } from '@/utils/userRoles';

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore();

    // Always ensure auth is initialized (check localStorage even if store says logged in)
    // This ensures token is always available in the store's reactive state
    if (!authStore.authToken) {
        authStore.initializeAuth();
    }

    // Check if route requires authentication
    if (to.meta.requiresAuth) {
        if (!authStore.isLoggedIn) {
            next('/');
            return;
        }
    }

    if (to.meta.requiresSystemAdmin) {
        if (!authStore.isLoggedIn) {
            next('/');
            return;
        }
        if (!authStore.isSystemAdmin) {
            next('/wiki/items');
            return;
        }
    }

    // If user is logged in and trying to access splash or login, redirect to role-appropriate dashboard
    const isOnboardingRoute = to.matched.some((m) => m.meta?.onboarding === true);
    if ((to.name === 'Splash' || to.name === 'Login' || to.name === 'Register' || isOnboardingRoute || to.name === 'AcceptInvite') && authStore.isLoggedIn) {
        const dashboardRoute = getDashboardByRole(authStore.currentUser) ?? getDashboardByUsername(authStore.currentUser?.username);
        next(dashboardRoute ?? '/dashboard');
        return;
    }

    // Freelancers: send to freelance dashboard when they hit the default (office) dashboard
    if (authStore.isLoggedIn && authStore.isFreelanceUser && to.path === '/dashboard' && to.meta?.dashboard === 'office') {
        next('/dashboard/freelance');
        return;
    }

    next();
});
export default router;
